import { TextField } from "@mui/material";
import { FormikProps } from "formik";

import Grid2 from "@mui/material/Grid2";
import { useAuth } from "src/context/auth";
import SalesFunnelItem from "./sales-funnel-item";
import { ISaleFunnelItem } from "src/interface/ISaleFunnelItem";
// ساخت schema برای اعتبارسنجی با yup

const SaleFunnelForm = ({
  formik,
  salesFunnelItem,
  setSalesFunnelItem,
}: {
  formik: FormikProps<any>;
  salesFunnelItem: ISaleFunnelItem[];
  setSalesFunnelItem: (salesFunnelItem: ISaleFunnelItem[]) => void;
}) => {
  const { user } = useAuth();
  return (
    <>
      <Grid2 container spacing={1} marginY={1}>
        <Grid2 size={12}>
          <TextField
            {...formik.getFieldProps("title")} // استفاده از ویژگی‌های فرمیک
            label="عنوان"
            placeholder="عنوان"
            error={formik.touched.title && Boolean(formik.errors.title)}
            helperText={
              (formik.touched.title && formik.errors.title) as boolean
            }
            variant="outlined"
            fullWidth
          />
        </Grid2>
      </Grid2>
      <SalesFunnelItem setRows={setSalesFunnelItem} rows={salesFunnelItem} />
    </>
  );
};

export default SaleFunnelForm;
